import { client } from './api';

/**
 * The document type list, as staff manage it.
 *
 * Roger's list rather than each agency's, so the same word means the same
 * thing everywhere and a report can count them. Reached only from Internal
 * Tools, which already requires a Strawhat super user.
 */

export interface ManagedFaxType {
  id: string;
  name: string;
  sort_order: number;
  is_active: boolean;
  /** How many faxes are filed under it, so retiring one is an informed act. */
  usage_count: number;
}

export async function listManagedFaxTypes(): Promise<ManagedFaxType[]> {
  const response = await client.get<ManagedFaxType[], unknown, true>({
    responseType: 'json',
    throwOnError: true,
    url: '/internal-tools/fax-types',
  });
  return response.data;
}

export async function createManagedFaxType(
  name: string,
  sortOrder: number
): Promise<ManagedFaxType> {
  const response = await client.post<ManagedFaxType, unknown, true>({
    body: { name, sort_order: sortOrder },
    responseType: 'json',
    throwOnError: true,
    url: '/internal-tools/fax-types',
  });
  return response.data;
}

export async function updateManagedFaxType(
  id: string,
  changes: { name?: string; sort_order?: number; is_active?: boolean }
): Promise<ManagedFaxType> {
  const response = await client.patch<ManagedFaxType, unknown, true>({
    body: changes,
    responseType: 'json',
    throwOnError: true,
    url: `/internal-tools/fax-types/${id}`,
  });
  return response.data;
}
